import React from "react";
import { Typography } from "@mui/material";
import ConfirmationDialog from "@/components/common/dialogs/ConfirmationDialog";

export interface RegenerateReportModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isPending: boolean;
}

export const RegenerateReportModal: React.FC<RegenerateReportModalProps> = ({
  open,
  onClose,
  onConfirm,
  isPending,
}) => (
  <ConfirmationDialog
    open={open}
    title="Regenerate Report"
    testIdPrefix="regenerateReport"
    onCancel={onClose}
    onConfirm={onConfirm}
    disableConfirmButton={isPending}
    confirmButtonTitle={isPending ? "Regenerating..." : "Confirm"}
    hideCloseIcon
  >
    <Typography variant="body1" sx={{ color: "text.primary" }}>
      Note: Changes made to supervisor, division, etc. will require a nightly sync before being reflected in a regenerated report.
      <br />
      <br />
      Regenerating the report will delete the old report and recreate it using any updates to supervisor, division, etc. This action cannot be undone.
      <br />
      <br />
      Are you sure you want to proceed?
    </Typography>
  </ConfirmationDialog>
);
